import { createReducer, on } from '@ngrx/store';

import { FeatureToggleType } from 'ish-core/feature-toggle.module';
import { DotCmsUveConfig } from 'ish-core/models/dot-cms-uve/dot-cms-uve-config.model';
import { PaypalClientConfig } from 'ish-core/models/paypal-client-config/paypal-client-config';
import { SparqueConfig } from 'ish-core/models/sparque/sparque-config.model';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';
import { Translations } from 'ish-core/utils/translate/translations.type';

import { environment } from '../../../../../environments/environment';

import { applyConfiguration, loadSingleServerTranslationSuccess } from './configuration.actions';

export interface ConfigurationState {
  baseURL?: string;
  server?: string;
  serverStatic?: string;
  serverWeb?: string;
  channel?: string;
  application?: string;
  hybridApplication?: string;
  identityProvider?: string;
  identityProviders?: Record<string, { type?: string; [key: string]: unknown }>;
  features?: FeatureToggleType[];
  addFeatures?: FeatureToggleType[];
  defaultLocale?: string;
  fallbackLocales?: string[];
  localeCurrencyOverride?: Record<string, string | string[]>;
  lang?: string;
  currency?: string;
  serverTranslations?: Record<string, Translations>;
  multiSiteLocaleMap?: Record<string, unknown>;
  sparque?: SparqueConfig;
  paypal?: PaypalClientConfig;
  // not synced via state transfer
  _deviceType?: DeviceType;
  /* DIAS CUSTOMIZATION START */
  dotCmsUveConfig?: DotCmsUveConfig;
  /* DIAS CUSTOMIZATION END */
}

const initialState: ConfigurationState = {
  baseURL: undefined,
  server: undefined,
  serverStatic: undefined,
  serverWeb: undefined,
  channel: undefined,
  application: undefined,
  hybridApplication: environment.hybridApplication,
  features: undefined,
  addFeatures: [],
  defaultLocale: environment.defaultLocale,
  fallbackLocales: environment.fallbackLocales,
  localeCurrencyOverride: environment.localeCurrencyOverride,
  lang: undefined,
  currency: undefined,
  serverTranslations: {},
  multiSiteLocaleMap: undefined,
  sparque: undefined,
  paypal: undefined,
  _deviceType: environment.defaultDeviceType,
  /* DIAS CUSTOMIZATION START */
  dotCmsUveConfig: undefined,
  /* DIAS CUSTOMIZATION END */
};

function addSingleTranslation(
  state: ConfigurationState,
  lang: string,
  key: string,
  translation: string
): ConfigurationState {
  return {
    ...state,
    serverTranslations: {
      ...state.serverTranslations,
      [lang]: { ...state.serverTranslations?.[lang], [key]: translation },
    },
  };
}

export const configurationReducer = createReducer(
  initialState,
  on(applyConfiguration, (state, action): ConfigurationState => ({ ...state, ...action.payload })),
  on(loadSingleServerTranslationSuccess, (state, action): ConfigurationState =>
    addSingleTranslation(state, action.payload.lang, action.payload.key, action.payload.translation)
  )
);
